// this is a function to parse html string to react component without using react-html-parser or dangerouslySetInnerHTML
import React from "react";

export const parseHTMLStringToReact = (htmlString: string) => {
  const parser = new DOMParser();
  const parsedDocument = parser.parseFromString(htmlString, "text/html");
  const body = parsedDocument.body;

  const traverseNodes = (node: Node): React.ReactNode => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      const children = Array.from(element.childNodes).map(traverseNodes);

      return React.createElement(
        element.tagName.toLowerCase(),
        {
          key: Math.random(),
          ...Object.fromEntries(
            Array.from(element.attributes).map((attr) => [
              attr.name,
              attr.value
            ])
          )
        },
        children
      );
    }
    return null;
  };

  return Array.from(body.childNodes).map(traverseNodes);
};
